import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { primaryColor } from '../theme';
import axios from 'axios';

const roles = {'Head Office Admin': ['Head Office Admin', 'Regional Manager', 'Content Editor', 'Content Reviewer', 'Trainer'], 'Regional Manager': ['Content Editor', 'Content Reviewer', 'Trainer']};
const AddUser = () => {
  const navigate = useNavigate();
  const [newUser, setNewUser] = useState({
    firstName: '',
    lastName: '',
    role: '',
    location: '',
    email: '',
    contact: '',
    status: 'Active',
    profilePicture: '',
    dateRegistered: new Date().toISOString().split('T')[0],
    lastActiveDate: new Date().toISOString().split('T')[0],
    createdBY: JSON.parse(localStorage.getItem('user')).id
  });
  const [error, setError] = useState({});
  const [serverError, setServerError] = useState('');
  const [allowedRoles, setAllowedRoles] = useState([]);
  const [userRole, setUserRole] = useState('');
  const [userLocation, setUserLocation] = useState('');

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user.id;
    if (user) {
      setUserRole(user.role);
      setUserLocation(user.location);
      setAllowedRoles(roles[user.role] || []);
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({ ...newUser, [name]: value });
    if (name === 'email') {
      setServerError('');
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!newUser.firstName) newErrors.firstName = 'First Name is required';
    if (!newUser.lastName) newErrors.lastName = 'Last Name is required';
    if (!newUser.role) newErrors.role = 'Role is required';
    if (!newUser.location) newErrors.location = 'Location is required';
    if (!newUser.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(newUser.email)) {
      newErrors.email = 'Email is not valid';
    }
    if (!newUser.contact) newErrors.contact = 'Contact is required';
    setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddUser = async () => {
    if (!validateForm()) return;

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/create-user`, newUser);
      navigate('/users');
    } catch (error) {
      console.error('Error adding user:', error);
      setServerError(error.response?.data?.msg || 'Failed to add user');
    }
  };

  if (userRole !== 'Head Office Admin' && userRole !== 'Regional Manager') {
    return (
      <Container maxWidth="sm" sx={{ mt: 4 }}>
        <Typography variant="h6" color="error">
          You do not have permission to add new users.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom style={{ color: primaryColor }}>
        Add New User
      </Typography>
      <TextField
        label="First Name"
        name="firstName"
        value={newUser.firstName}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        error={!!error.firstName}
        helperText={error.firstName}
      />
      <TextField
        label="Last Name"
        name="lastName"
        value={newUser.lastName}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        error={!!error.lastName}
        helperText={error.lastName}
      />
      <FormControl fullWidth margin="normal" error={!!error.role}>
        <InputLabel>Role</InputLabel>
        <Select
          label="Role"
          name="role"
          value={newUser.role}
          onChange={handleInputChange}
        >
          {allowedRoles.map(role => (
            <MenuItem key={role} value={role}>{role}</MenuItem>
          ))}
        </Select>
        {error.role && <Typography variant="body2" color="error">{error.role}</Typography>}
      </FormControl>
      {userRole === 'Head Office Admin' ? (
        <TextField
          label="Region"
          variant="outlined"
          fullWidth
          margin="normal"
          name="location"
          value={newUser.location}
          onChange={handleInputChange}
          error={!!error.location}
          helperText={error.location}
        />                                                            
      ) : (
        <TextField
          label="Region"
          variant="outlined"
          fullWidth
          margin="normal"
          name="location"
          value={userLocation}
          onChange={handleInputChange}
          error={!!error.location}
          helperText={error.location}
        />
      )}
      <TextField
        label="Email"
        name="email"
        value={newUser.email}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        error={!!error.email}
        helperText={error.email}
      />
      <TextField
        label="Contact"
        name="contact"
        value={newUser.contact}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        error={!!error.contact}
        helperText={error.contact}
      />
      {serverError && (
        <Typography variant="body2" color="error" gutterBottom>
          {serverError}
        </Typography>
      )}
      <Box mt={2} display="flex" justifyContent="space-between">
        <Button variant="contained" color="primary" onClick={handleAddUser} sx={{ backgroundColor: primaryColor }}>
          Submit
        </Button>
        <Button variant="contained" color="secondary" onClick={() => navigate('/users')}>
          Cancel
        </Button>
      </Box>
    </Container>
  );
};

export default AddUser;